// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"364":"74d2d39882fca80532ac","961":"e4a7d9f76e91847c7e32","2467":"4bdf758d56894822e1aa","2648":"68d06d89713590e53957","4848":"f92b39601bfe4709ad9b","6540":"e953a3de5b024f0b2565"}[chunkId] + ".js";
};